<!--
 * @name: 萝卜兄台
 * @Date: 2022-07-22 17:26:07
 * @LastEditors: DESKTOP-IQPBHI4\mi leili995997651@qq.com
 * @LastEditTime: 2022-07-26 16:05:09
 * @FilePath: \recognize_www\src\page\behind\account\components\userInfo\index.vue
 * @Description: 这是描述
-->
<template>
  <div class="userInfo">
    <div class="userInfoTitle">{{ $t(`account.basicSetup`) }}</div>
    <div class="userInfoConte">
      <div class="le">
        <a-form :model="formState" name="basic" ref="formRef" :label-col="labelCol" @finish="onFinish">
          <a-form-item :label="t('account.nickName')" name="realname">
            <a-input v-model:value="formState.realname" />
          </a-form-item>
          <a-form-item :label="t('account.gender')" name="sex">
            <a-radio-group v-model:value="formState.sex" name="radioGroup">
              <a-radio value="MALE">{{ $t(`account.mal`) }}</a-radio>
              <a-radio value="FEMALE">{{ $t(`account.female`) }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="t('account.mobile')" name="mobile">
            <a-input v-model:value="formState.mobile" />
          </a-form-item>
          <a-form-item :label="t('account.mailBox')" name="email">
            <a-input v-model:value="formState.email" />
          </a-form-item>
          <a-form-item :label="t('account.address')" name="address">
            <a-input v-model:value="formState.address" />
          </a-form-item>

          <a-form-item :wrapper-col="{ offset: 7, span: 17 }">
            <a-button type="primary" html-type="submit" :loading="store.sbLoading">{{ $t(`account.updateBasic`)
              }}</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="ri">
        <div>{{ $t(`account.avatar`) }}</div>
        <div class="riImg">
          <img class="riImages" :src="store.userInfoData.pic
            ? C.ApiImage + store.userInfoData.pic
            : inter.getImageUrl('no-avatar3.png')
            " />
        </div>
        <div class="riBtn">
          <a-upload v-model:file-list="fileList" name="file" :customRequest="customRequest" :maxCount="1"
            :showUploadList="false">
            <a-button :loading="store.fileLoading">
              <upload-outlined></upload-outlined>
              {{ $t(`account.changeAvatar`) }}
            </a-button>
          </a-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { loginStore } from '../../../../../store/login'
import { ref, reactive, onBeforeMount } from 'vue'
import type { FormInstance } from 'ant-design-vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import inter from '../../../../../utils/shared'
import C from '../../../../../utils/constants'
import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()


interface FormState {
  realname: string
  sex: string
  mobile: string
  email: string
  address: string
  pic: string
}
const formRef = ref<FormInstance>()
const formState = reactive<FormState>({
  realname: '',
  sex: '',
  mobile: '',
  email: '',
  address: '',
  pic: '',
})
const labelCol = { style: { width: '100px' } }

const store = loginStore()

const fileList = ref<any>([])

onBeforeMount(() => {
  initData()
})

/** 提交信息修改 */
const onFinish = () => {
  let params = {
    payload: {
      ...formState,
    },
    callback: () => {
      message.success(`${t('account.success')}`, 2)
      initData()
    },
  }
  store.getUpdateUserInfo(params)
}
/** 图片上传 */
const customRequest = () => {
  if (fileList.value[0].size / 1024 / 1024 > 1) {
    fileList.value = []
    message.warning(`${t('account.warning')}`)
    return
  }
  let fileForm = new FormData()
  fileList.value.map((e: any) => {
    fileForm.append('files', e.originFileObj)
  })
  let params = {
    payload: fileForm,
    callback: (data: any) => {
      // message.success('修改成功！', 2)
      formState.pic = data[0].viewUrl
      onFinish()
      fileList.value = []
    },
  }
  store.getFileUpload(params)
}

/** 信息查询 */
const initData = () => {
  let params = {
    callback: (data: any) => {
      formState.realname = data.realname
      formState.sex = data.sex
      formState.mobile = data.mobile
      formState.email = data.email
      formState.address = data.address
      formState.pic = data.pic
    },
  }
  store.getUserInfo(params)
}
</script>

<style lang="less">
@import url('./index.less');
</style>
